import React, { useState } from "react";

import { Button } from "primereact/button";
import MaintenanceFormDialog from "./MaintenanceFormDialog";

const MaintenanceDialogButton: React.FC = () => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <div className="flex">
      <Button size="small" type="button" icon="pi pi-plus" onClick={() => setShowDialog(true)} />
      <MaintenanceFormDialog showDialog={showDialog} setShowDialog={setShowDialog} />
    </div>
  );
};

export default MaintenanceDialogButton;
